import { Dispatch, MutableRefObject, SetStateAction, useEffect } from "react"
import { IGameplayStateResponse } from "@/store/apis/gameplayAPI"
import { IMatchSessionResponse } from "@/store/apis/matchAPI"
import { ICardItem } from ".."
import { IUseCardItemsReturn } from "./useCardItems"

interface IUseMatchEndRevealParams {
  isMatchActive: boolean
  matchSession: IMatchSessionResponse | undefined
  gameState: IGameplayStateResponse | undefined
  isMe: (playerIdentic?: string, currentPlayerId?: string) => boolean

  refItems: MutableRefObject<ICardItem[]>
  setItems: Dispatch<SetStateAction<ICardItem[]>>
  moveTo: IUseCardItemsReturn["moveTo"]
}

export const useMatchEndReveal = ({
  isMatchActive,
  matchSession,
  gameState,
  isMe,
  refItems,
  setItems,
  moveTo
}: IUseMatchEndRevealParams): void => {
  useEffect(() => {
    if (isMatchActive) return

    let aborted = false

    ;(async () => {
      await new Promise((resolve) => setTimeout(resolve, 100))

      if (aborted) return

      const opponentCardsSnapshot = matchSession?.snapshot?.hands.filter(
        (h) =>
          !isMe(h.player) &&
          !(
            gameState?.currentCard?._id === h.card?._id &&
            gameState?.currentPlayerId === h.player
          )
      )

      const opponentCardData = refItems.current.filter(
        (i) => i.owner === "opponent"
      )

      setItems((prev) => {
        const opponentCardIds = new Set(opponentCardData.map((c) => c.id))
        const rest = prev.filter((i) => !opponentCardIds.has(i.id))

        const updatedCards = opponentCardData.map((card, index) => ({
          id: card.id,
          owner: "opponent" as const,
          status: card.status,
          order: card.order,
          data: opponentCardsSnapshot?.[index]?.card
        }))
        return [...rest, ...updatedCards]
      })

      opponentCardData.forEach((card) => {
        moveTo(card.id, "opponent-view", "opponent-view")
      })
    })()

    return () => {
      aborted = true
    }
  }, [isMatchActive])
}
